import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from '../static/common-functions';
import { v_DispatchPartBus } from './v_DispatchPartBus';

export class DispatchPartsBus extends BaseBus
{
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.addedDate = DateFunctions.getDate(this.addedDate);
        this.sageDt = DateFunctions.getDate(this.sageDt);

    }
    CID(): any {
        return this.dispatchPartId;
    }

    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    setBeforeSave() {
        let dNow = DateFunctions.getDateNow();
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = dNow;
        }
        if (!CommonFunctions.hasValue(this.updateDt)) {
            this.updateDt = dNow;
        }

        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.addedDate = DateFunctions.getDateTimeWithUTCOffset(this.addedDate);
        this.sageDt = DateFunctions.getDateTimeWithUTCOffset(this.sageDt);
    }
    setFromView(busObj: v_DispatchPartBus) {
        this.dispatchPartId = busObj.dispatchPartId;
        this.dispatchId = busObj.dispatchId;
        this.personId = busObj.personId;
        this.inventoryLocationXrefid = busObj.inventoryLocationXREFId;
        this.quantity = busObj.quantity;
        this.addedDate = busObj.addedDate;
        this.insertDt = busObj.insertDt;
        this.insertUserId = busObj.insertUserId;
        this.updateDt = busObj.updateDt;
        this.updateUserId = busObj.updateUserId;
        this.onConstDraw = busObj.onConstDraw == true ? true : false;
        this.sageDt = DateFunctions.hasReasonableDateValue(busObj.sageDt) ? busObj.sageDt : null;
        this.inventoryLocationId = busObj.inventoryLocationId;
        this.inventoryId = busObj.inventoryId;
        this.isAdded = busObj.isAdded;
        this.isUpdated = busObj.isUpdated;
    }
    dispatchPartId: any;
    dispatchId: any;
    personId: any;
    inventoryLocationXrefid: any;
    quantity: number;
    addedDate: Date;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    onConstDraw: boolean;
    sageDt: Date;
    inventoryLocationId: any;
    inventoryId: any;
}
